import React from "react";

import gql from "graphql-tag";
import { Query } from '@apollo/client/react/components';
import { client } from "../index";

import { withRouter } from "react-router";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

import LoggedInMenu from "./LoggedInMenu";
import MailboxMessage from "./MailboxMessage";
import MessageEditorModal from "./MessageEditorModal";
import OcrProcessDropzone from "./OcrProcessDropzone";
import UploaderButton from "./UploaderButton";
import SearchButton from "./SearchButton";

import LoadingView from "./LoadingView";
import ErrorView from "./ErrorView";

const MAX_MESSAGES = 500;

const GET_MESSAGES = gql`
  query messages($limit: Int) {
    messages(limit: $limit) {
      threadId
      msgId
      message
      sender
      recipient
      subject
      createdAtDate
      createdAtTime
      isRead
      recipientIsCustomer
      attachments {
        name
        downloadUrl
      }
    }
  }
`;

const TOGGLE_MESSAGE_READ = gql`
  mutation toggleMessageRead($msgId: Int!) {
    toggleMessageRead(msgId: $msgId) {
      success
    }
  }
`;

const REPLY_TO_MESSAGE = gql`
  mutation replyToMessage($msgId: Int!, $subject: String, $message: String) {
    replyToMessage(msgId: $msgId, subject: $subject, message: $message) {
      success
    }
  }
`;

interface IMessageListProps {
  history: any;
  showTeamModal?: boolean;
}

class MessageList extends React.Component<IMessageListProps> {
  state: {
    limit: number;

    editorIsOpen: boolean;
    replyTo?: number;
    recipient?: string;
    subject?: string;
    message?: string;

    sendSuccess: boolean;
    sendError: boolean;
    showModal: boolean;
  };

  constructor(props: any) {
    super(props);

    this.state = {
      limit: 10,
      editorIsOpen: false,
      message: "",
      sendSuccess: false,
      sendError: false,
      showModal: false,
    };

    this.toggleRead = this.toggleRead.bind(this);
    this.updateMessageText = this.updateMessageText.bind(this);
    this.updateSubject = this.updateSubject.bind(this);
    this.submitMessage = this.submitMessage.bind(this);
  }

  async toggleRead(msgId: number) {
    const success = await client.mutate({
      mutation: TOGGLE_MESSAGE_READ,
      variables: { msgId: msgId },
      refetchQueries: [
        { query: GET_MESSAGES, variables: { limit: this.state.limit } },
      ],
    });

    return success;
  }

  composeReply(m: any) {
    this.setState({
      ...this.state,
      editorIsOpen: true,
      replyTo: m.msgId,
      recipient: m.recipient,
      subject: "AW: " + m.subject,
      sendSuccess: false,
      sendError: false,
    });
  }

  updateMessageText(text: string) {
    this.setState({ ...this.state, message: text });
  }

  updateSubject(text: string) {
    this.setState({ ...this.state, subject: text });
  }

  async submitMessage() {
    const success = await client.mutate({
      mutation: REPLY_TO_MESSAGE,
      variables: {
        msgId: this.state.replyTo,
        subject: this.state.subject,
        message: this.state.message,
      },
      refetchQueries: [
        { query: GET_MESSAGES, variables: { limit: this.state.limit } },
      ],
    });

    if (success && success.data.replyToMessage.success === true) {
      this.setState({
        ...this.state,
        replyTo: undefined,
        recipient: undefined,
        subject: undefined,
        message: "",
        sendSuccess: true,
      });
    } else {
      this.setState({ ...this.state, sendError: true });
    }
  }

  render() {
    return (
      <>
        <LoggedInMenu history={this.props.history} />
        <OcrProcessDropzone
          show={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
        />
        <MessageEditorModal
          onHide={() => this.setState({ ...this.state, editorIsOpen: false })}
          show={this.state.editorIsOpen}
          recipient={this.state.recipient}
          subject={this.state.subject}
          updateSubject={this.updateSubject}
          updateMessageText={this.updateMessageText}
          message={this.state.message}
          submitMessage={this.submitMessage}
          success={this.state.sendSuccess}
          error={this.state.sendError}
        />
        <div className="content-wrapper">
          <Container fluid>
            <Row>
              <Col xs={12} lg={10} className="main">
                <div className="contentheader">
                  <Container fluid>
                    <Row className="align-items-stretch py-3">
                      <Col xs={6} lg={7}>
                        <UploaderButton
                          onClick={() =>
                            this.setState({
                              ...this.state,
                              showModal: true,
                            })
                          }
                        />
                      </Col>
                      <Col xs={6} lg={5}>
                        <SearchButton
                          history={this.props.history}
                        ></SearchButton>
                      </Col>
                    </Row>
                  </Container>
                </div>
                <div className="sitecontent"></div>
                <Container fluid>
                  <Row className="pt-3 pb-1">
                    <Col xs={8}>
                      <h1 className="underline">
                        <span className="icon-inbox"></span>Mein Postfach
                      </h1>
                    </Col>
                  </Row>
                </Container>
                <div className="wrapper-messages">
                  <Query
                    query={GET_MESSAGES}
                    variables={{ limit: this.state.limit }}
                    partialRefetch={true}
                    returnPartialData={true}
                  >
                    {({ loading, error, data, refetch }: any) => {
                      if (loading) {
                        return <LoadingView />;
                      }

                      if (error) {
                        return <ErrorView error={error} />;
                      }

                      let content: any;

                      if (data.messages.length < this.state.limit) {
                        content = (
                          <div
                            style={{
                              display: "block",
                              textAlign: "center",
                              textTransform: "uppercase",
                            }}
                          >
                            Keine weiteren Nachrichten
                          </div>
                        );
                      } else if (this.state.limit === MAX_MESSAGES) {
                        content = (
                          <div
                            style={{
                              display: "block",
                              textAlign: "center",
                              textTransform: "uppercase",
                            }}
                          >
                            Limit erreicht. Zeige keine weiteren Nachrichten
                          </div>
                        );
                      } else {
                        content = (
                          <div
                            style={{
                              display: "block",
                              textAlign: "center",
                              textTransform: "uppercase",
                            }}
                          >
                            <Button
                              variant="light"
                              onClick={() => {
                                this.setState({
                                  ...this.state,
                                  limit: this.state.limit + 10,
                                });
                              }}
                            >
                              Weitere Nachrichten laden
                            </Button>
                          </div>
                        );
                      }

                      if (data.messages.length === 0) {
                        return (<>Keine Nachrichten vorhanden.</>);
                      }

                      return (
                        <>
                          {data.messages.map((m: any, idx: number) => (
                            <MailboxMessage
                              key={idx}
                              subject={m.subject}
                              body={m.message}
                              date={m.createdAtDate}
                              time={m.createdAtTime}
                              isRead={m.isRead}
                              sender={m.sender}
                              recipient={m.recipient}
                              msgId={m.msgId}
                              toggleRead={this.toggleRead}
                              recipientIsCustomer={m.recipientIsCustomer}
                              reply={() => this.composeReply(m)}
                              attachments={m.attachments}
                            />
                          ))}
                          {content}
                        </>
                      );
                    }}
                  </Query>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }
}

export default MessageList;
